import { useReduxState } from 'hooks';
import { RichTextEditorInput } from 'components/common/richTextEditor';

interface Props {
  ariaLabel?: string;
  backgroundColor?: string;
  color?: string;
  colorPickerEnabled?: boolean;
  content: string;
  isPlainText?: boolean;
  linkColor?: string;
  onChange: (content: string) => void;
  padding?: string;
  placeholder: string;
  showBorder?: boolean;
  style?: React.CSSProperties;
}

const TextEditor = ({
  ariaLabel,
  backgroundColor = 'white',
  color,
  colorPickerEnabled = false,
  content,
  isPlainText,
  linkColor,
  onChange,
  padding = '8px 10px',
  placeholder,
  showBorder = false,
  style
}: Props) => {
  const {
    serverConfig: { editorTextColorOptions },
    theme
  } = useReduxState();

  const colorPickerColors = editorTextColorOptions?.length
    ? editorTextColorOptions
    : [theme.successStandaloneColor, theme.dangerColor];

  return (
    <div
      className="text-editor"
      style={style}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <RichTextEditorInput
        colorPickerColors={colorPickerEnabled ? colorPickerColors : undefined}
        linkOptions={{ HTMLAttributes: { rel: null, target: null } }}
        // NOTE: 50 000 for maxLength is arbitrary for now, this could be
        // changed or made to accept a prop so we can have limits for different
        // inputs in different blocks in the editor
        maxLength={50000}
        maxLengthShowError={true}
        maxLengthShowInfo={false}
        onChange={onChange}
        placeholder={placeholder}
        rows={1}
        value={content}
        withBorder={showBorder}
        {...(isPlainText
          ? {
              formatting: false,
              singleLine: true,
              singleLineRemoveParagraph: true
            }
          : {})}
      />

      <style jsx>{`
        .text-editor :global(.vuo-rich-text-editor) {
          background-color: ${backgroundColor || 'inherit'};
          color: ${color || theme.textColor};
          font-size: 1.6rem;
          min-height: max-content;
          padding: ${padding};
        }
        .text-editor :global(.vuo-rich-text-editor a) {
          color: ${linkColor || theme.linkColor};
        }
      `}</style>
    </div>
  );
};

export default TextEditor;
